export default __webpack_public_path__ + "static/saudiback-b648c4ab02321af315dc47b4b9598537.webp";